import type { Locale } from "@/lib/i18n";
import { pl, type CServicesTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cServicesTranslations: Record<Locale, CServicesTranslations> = {
  pl,
  en,
  de,
};

export type { CServicesTranslations };
